import { render, staticRenderFns } from "./traineePostassessmentList.vue?vue&type=template&id=3cc43f6f&scoped=true"
import script from "./traineePostassessmentList.vue?vue&type=script&lang=js"
export * from "./traineePostassessmentList.vue?vue&type=script&lang=js"
import style0 from "./traineePostassessmentList.vue?vue&type=style&index=0&id=3cc43f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc43f6f",
  null
  
)

export default component.exports